<script>
import LogDetailsMixin from './log-details.mixin.js'

export default {
  name: 'FeedLogDetails',
  mixins: [LogDetailsMixin],
}
</script>

<template>
  <expanded-row :columns="columns">
    <template v-if="action === 'action_update_feed_merchant'">
      <div slot="expanded-row-cell-1">
        <div :class="$style.subrow">
          Feed Merchant Name
        </div>
      </div>

      <div slot="expanded-row-cell-2">
        <div :class="$style.subrow">
          {{ metadata.name }}
        </div>
      </div>
    </template>
  </expanded-row>
</template>

<style lang="scss" module>
  .subrow {
    margin-bottom: 20px;

    &:last-of-type {
      margin-bottom: 0;
    }
  }
</style>
